import React from 'react';
import { string } from 'prop-types';

// Import styles
import { Container, Title } from './style';

export const RecordingsHeader = ({ title }) => {
	return (
		<Container>
			<Title>{title}</Title>
		</Container>
	);
};

RecordingsHeader.propTypes = {
	title: string.isRequired
};
